import addDays from "date-fns/addDays";

var date = new Date(), y = date.getFullYear(), m = date.getMonth();


export const predefinedRanges = [
  {
    label: "Today",
    value: [new Date(), new Date()],
  },
  {
    label: "Last 7 days",
    value: [addDays(new Date(), -7), new Date()],
  },
  {
    label: "Last 30 days",
    value: [addDays(new Date(), -30), new Date()],
  },
  {
    label: "This month",
    value: [new Date(y, m, 1), new Date(y, m + 1, 0)],
  },
  {
    label: "This year",
    value: [new Date(y, 0, 1), new Date(y, 11, 31)],
  },

];

export const filterList = [
  {
    name: "dateRange",
    label: "Date",
    type: "date-range",
  },
  {
    name: "status",
    label: "Email Sent",
    list: [
      { label: "Yes", value: "sent" },
      { label: "No", value: "not_sent" },
    ],
    type: "select",
  },
  {
    name: "type",
    label: "Tribute Type",
    list: [
      { label: "In honor of", value: "In honor of" },
      { label: "In memory of", value: "In memory of" },
      { label: "None", value: "none" },
    ],
    type: "select",
  },
  {
    name: "amountRange",
    label: "Donation Amount",
    type: "number-range",
  },
  {
    name: "ledger",
    label: "Ledger",
    type: "ledger",
  },
]